/* global io */
import LiveCuepointsManager from './LiveCuepointsManager';
import Utils from '../Utils/Utils';

export default class Live {

    constructor(sdk) {

        this.sdk = sdk;

        this.liveCuepointsManager = new LiveCuepointsManager(this.sdk);
        this._socket = io(this.apiUrl);
        this._socket.on('connect', (socket) => {
            console.log('socket connected');
        });
        this._socket.on('streamInfo', async(data) => {
            if (!this.isLive) {
                this.isLive = data.live;
            }
            if (this.isLive.live != data.live) {
                console.log('go');
                this.isLive = data;
                await this.reLoadInfo();
            }
        });
        
        this.lastSpeaker;;

        this._socket.on('liveAction', (data) => {
            console.log('liveAction', data);
            if(data.action == 'speaker') {
				if(document.getElementById('chapter-' + data.id))
					return;
                let chapter = this.getCurrentLive('chapter');
                console.log('chapter', chapter);
                for(var i in window.sdk.live.chapters) {
                    if(window.sdk.live.chapters[i].id == data.chapterRef.value.chapterId) {
                        let index = window.sdk.live.chapters[i].speakers.findIndex(a => a.id === data.id);
                        if(index === -1) {															
                            data.value.speaker.firstname = decodeURIComponent(escape(data.value.speaker.firstname));
			                data.value.speaker.lastname = decodeURIComponent(escape(data.value.speaker.lastname));
			                data.value.speaker.organization = decodeURIComponent(escape(data.value.speaker.organization));
                            let index = window.sdk.live.chapters[i].speakers.push(data) - 1;
                            this.lastSpeaker = {
                                chapI: i,
                                speakI: index
                            }
                            window.sdk.emit('refreshLiveOdj');
                        }
                    }
                }
            }
			
			if(data.action == 'chapter' && window.sdk.isExtended()) {
				try {
					let diff = data.live_second - window.sdk.player().dataTime.currentTime;
					console.log('we clear speaker panel in', diff, 'seconds');
					setTimeout(() => {			
						document.querySelector('.fixed-speaker__name').innerHTML = '';
						document.querySelector('.fixed-speaker__job').innerHTML = '';
						document.querySelector('.fixed-speaker__img img').src = '/public/trans.png';
						document.querySelector('.fixed-speaker__group').innerHTML = '';
                        document.querySelector('.fixed-speaker').classList.add('empty');
					}, diff * 1000);
				}
				catch(err) {
				}
			}
            
            if(data.action == 'speaker' || data.action == 'chapter') {
                try {
                    if(this.lastSpeaker && window.sdk.live.chapters[this.lastSpeaker.chapI] && window.sdk.live.chapters[this.lastSpeaker.chapI].speakers[this.lastSpeaker.speakI]) {
                        if(window.sdk.live.chapters[this.lastSpeaker.chapI].speakers[this.lastSpeaker.speakI].duration == 0) {
                            console.log('on met à jour la duration du speaker')
                            window.sdk.live.chapters[this.lastSpeaker.chapI].speakers[this.lastSpeaker.speakI].duration = data.live_second - window.sdk.live.chapters[this.lastSpeaker.chapI].speakers[this.lastSpeaker.speakI].live_second;
                            window.sdk.emit('refreshLiveOdj');
                        }
                    }
                }
                catch(err) {
                    console.log('err', err);
                }
            }
            
            if (!window.sdk.isOdjOnly()) {
                this.liveCuepointsManager.addAction(data);
            }
            
            //this.checkDuration();
        })

        this._socket.on('liveActionSynchro', (data) => {
            console.log('liveActionSynchro', data, window.sdk.isOdjOnly());
            if (window.sdk.isOdjOnly()) {
                console.log('go ')

                if (data.action != 'chapter')
                    return;

                setTimeout(() => {
                    data.value = JSON.parse(data.value);
                    this.updateOdjOnly(data.value.chapterId);

                }, 3000);
                return false;


            }
        })
        
        this._socket.on('liveStarted', () => {
            document.location.href = document.location.href;
        })
        
        setTimeout(async () => {
            if (window.sdk.isOdjOnly()) {
                await this.reLoadInfo();
                console.log(this.streamInfo.program.sub_program_id);
                this.updateOdjOnly(this.streamInfo.program.sub_program_id);
            };
        }, 2000);



        this._socket.on('renewStream', (data) => {
            console.log('renewStream', data, this.livesPublicInfo)
            if (data.stream == this.livesPublicInfo.streamName) {
                document.location.href = document.location.href;
            }
        });

    }
    
    checkDuration() {
        let finded = false;
        for(var i in window.sdk.live.chapters) {
            for(var j in window.sdk.live.chapters[i].speakers) {
                let speaker = window.sdk.live.chapters[i].speakers[j];
                if(!speaker.duration || speaker.duration == 0) {
                    let int = parseInt(j);
                    let next = int + 1;
                    if(window.sdk.live.chapters[i].speakers[next]) {
                        speaker.duration = window.sdk.live.chapters[i].speakers[next].live_second - speaker.live_second;
                        console.log('finded et on met ajoute la duration', speaker)
                        finded = true;
                    }
                }
            }
        }
        if(finded)
            window.sdk.emit('refreshLiveOdj');
    }

    updateOdjOnly(chapterId) {
        let elements = document.querySelectorAll('.odj p');
        Array.prototype.forEach.call(elements, function(el, i) {
            el.style.color = '#333'
        });
        elements = document.querySelectorAll('#chapter-' + chapterId + ' p');
        Array.prototype.forEach.call(elements, function(el, i) {
            el.style.color = window.custom.color.p1;
        });
        document.getElementById('chapter-' + chapterId).scrollIntoView();
    }

    isInPublicLive() {
        console.log('isInPublicLive', this.isLive.live, this.streamInfo.program.live_state)
        if (this.isLive.live && this.streamInfo.program.live_state)
            return true;
        else
            return false;
    }

    getDurationOfCuepoint(type, index) {
        return this.liveCuepointsManager.cuepointsType[type].getDuration(index);
    }

    getCuepointByIndex(type, index) {
        return this.liveCuepointsManager.cuepointsType[type].cuepointsA[index];
    }

    getCuepointById(type, id) {
        return this.liveCuepointsManager.cuepointsType[type].cuepoints[id];
    }

    getCuepointDataByIdndex(type, index) { 
		return this.liveCuepointsManager.cuepointsType[type].cuepoints[this.getCuepointByIndex(type, index).id];
    }

    getCurrentLive(type) {
        return this.liveCuepointsManager.cuepointsType[type].currentLive;
    }

    getCurrentCue(type) {
        return this.liveCuepointsManager.cuepointsType[type].getCurrentCue();
    }

    async loadCuepoints() {
        await this.liveCuepointsManager.load();
    }

    getLastClickedCuepoint(type) {
        return this.liveCuepointsManager.cuepointsType[type].getLastClicked();
    }

    async loadInfo(programId) {
        this.streamInfo = await this.sdk.fetch('/stream/' + programId)
    }

    async reLoadInfo() {
        this.streamInfo = await this.sdk.fetch('/stream/' + window.programId);
        this.sdk.emit('monitorStream', this.isLive.live, this.streamInfo.program.live_state, this.streamInfo.program.record_state, this.isInPublicLive());
        return this.streamInfo;
    }

    async initMonitoringStream() {
        this.isLive = await this.monitorStream(window.programId);
        //this.sdk.emit('monitorStream', this.isLive.live);
        await this.reLoadInfo();
        this._socket.emit('monitorStream', window.programId);
    }

    async monitorStream(programId) {
        return await this.sdk.fetch('/stream/' + programId + '/monitor')
    }

    getStreamInfo() {
        return this.streamInfo;
    }

    async setLiveCurrent(type, id) {
        this.liveCuepointsManager.cuepointsType[type].lastClicked = id;
        return await this.sdk.fetch('/stream/' + window.programId + '/' + type + '/' + id, {
            method: 'POST'
        })
    }



    async getLiveChapters(programId) {
		console.log('this.livesPublicInfo', this.livesPublicInfo);
		while(!this.livesPublicInfo) {
			await window.sdk.live.loadPublicInfo();
			await Utils.sleep(10);
			
		}console.log('this.livesPublicInfo2', this.livesPublicInfo);
		
        let params = '?dvr_name=' + this.livesPublicInfo.streamName;

        this.chapters = await this.sdk.fetch('/live/chapters/' + programId + params)
        return this.chapters;
    }


    async loadPublicInfo() {
        this._socket.emit('monitorPublicStream', window.programId);
        

        this.livesPublicInfo = await this.sdk.fetch('/stream/' + window.programId + '/public');
        this.streamUrl = this.livesPublicInfo.streamUrl;
        await this.getLiveChapters(window.programId);
        console.log(this.streamUrl);
    }


    //manager
    async startLive() {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/publish/start', {
            method: 'POST'
        })
        await this.reLoadInfo();
        return res;
    }

    async stopLive() {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/publish/stop', {
            method: 'POST'
        })
        await this.reLoadInfo();
        return res;
    }

    async startRecord() {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/record/start', {
            method: 'POST'
        })
        await this.reLoadInfo();
        return res;
    }

    async stopRecord() {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/record/stop', {
            method: 'POST'
        })
        await this.reLoadInfo();
        return res;
    }

    async renew() {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/renew', {
            method: 'POST'
        })
        this.streamInfo.program = res.program;
    }

    async streamMedia(image) {
        let res = await this.sdk.fetch('/stream/' + window.programId + '/streammedia', {
            method: 'POST',
            body: JSON.stringify({
                image: image
            }),
            headers: {
                "Content-Type": "application/json"
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/Sdk/Live.js